<div [formGroup]="formGroup">
  <app-consents [isRegistrationScreen]="true"
                formControlName="consents"
                class="field-consents"
                [consentsTranslations]="consentsTranslations"/>
  <div class="tw-mb-[25px]">
    @if (identifierType === identifierMsisdnType) {
      @if (formGroup.controls['consents'].value.email_marketing) {
        <div>
          <div [ngClass]="{'is-focused': $any(email).isFocused, 'has-error': formErrors.email}"
               class="form-group label-static is-empty email form-control-email">
            <label class="control-label">
              <span>{{ 'attributes.email' | translate }}</span>
            </label>
            <input class="form-control field-email"
                   type="email"
                   [formControl]="$any(formGroup.controls['email'])"
                   #email
                   appFocusable
                   (onFocusChange)="$any(email).isFocused = $event">
            <app-input-errors [errorsForField]="formErrors.email"
                              [translationKey]="'errors.members'"/>
          </div>
        </div>
      }
    }
    @if (identifierType === identifierEmailType) {
      @if (formGroup.controls['consents'].value.sms_marketing) {
        <div>
          <app-msisdn-input [passedFormControl]="$any(formGroup.controls['msisdn'])"
                            [showErrors]="true"
                            [formErrors]="formErrors.msisdn"/>
        </div>
      }
    }
  </div>
</div>
